// extracted by mini-css-extract-plugin
export default {"root":"TaskHistory_root__mWGdy","date":"TaskHistory_date__lGf-N"};